import { publicEnv } from '~/features/environment/public';
import { Currency } from '~/features/internationalization/models/currency';
import { queryUdacityService } from '~/utils/query-udacity-service';

import { DynamicPrice, dynamicPriceSchema } from '../models/dynamic-price';

export async function getDynamicPrice({
  currency,
  formalDegreeKey,
  coupon,
}: {
  currency: Currency;
  formalDegreeKey: string;
  coupon?: string;
}): Promise<DynamicPrice> {
  const params = new URLSearchParams({
    currency,
    payment_plan_type: 'recurring',
    type: 'AllAccessSku',
    add_degree_application: 'true',
    formal_degree_key: formalDegreeKey,
  });

  if (coupon) {
    params.set('coupon', coupon);
  }

  return await queryUdacityService({
    url: `${publicEnv.NEXT_PUBLIC_BRAAVOS_URL}/prices?${params.toString()}`,
    method: 'GET',
    zodSchema: dynamicPriceSchema,
  });
}
